export * from "./encryption.js";
export * from "./licenses.js";
export * from "./urls.js";
export * from "./License.js";
export * from "./NullLicense.js";
export * from "./getWcpProjectEnvironment.js";

export const WCP_FEATURE_LABEL = {
    seats: "User Seats",
    multiTenancy: "Multi-tenancy",
    advancedPublishingWorkflow: "Advanced Publishing Workflow (APW)",
    advancedAccessControlLayer: "Advanced Access Control Layer (ACL)",
    auditLogs: "Audit Logs",
    recordLocking: "Record Locking",
    fileManager: "File Manager"
};
